import { render, staticRenderFns } from "./WarehouseTransferRequest.vue?vue&type=template&id=a34b1572"
import script from "./WarehouseTransferRequest.vue?vue&type=script&lang=js"
export * from "./WarehouseTransferRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports